import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import BlogGrid from '../components/blog/BlogGrid';
import SEO from '../components/layout/SEO';

const BlogPage = () => {

  return (
    <HelmetProvider>
      <div className="blog-page" style={{
  marginTop: '50px' 
}}
>
        <SEO 
          title="Blog - Resumeslip" 
          description="Read our latest articles on career tips, resume writing, and professional development."
        />
        <BlogGrid />
      </div>
    </HelmetProvider>
  );
};


export default BlogPage;